import { CurrencyEnum } from '@codezo/graphql';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CurrencyInfo {
	code: CurrencyEnum;
	name: string;
	symbol: string;
	flag: string;
}

export const CURRENCY_INFO: Record<CurrencyEnum, CurrencyInfo> = {
	[CurrencyEnum.Dkk]: { code: CurrencyEnum.Dkk, name: 'Danish Krone', symbol: 'kr', flag: '🇩🇰' },
	[CurrencyEnum.Usd]: { code: CurrencyEnum.Usd, name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
	[CurrencyEnum.Eur]: { code: CurrencyEnum.Eur, name: 'Euro', symbol: '€', flag: '🇪🇺' },
	[CurrencyEnum.Gbp]: { code: CurrencyEnum.Gbp, name: 'British Pound', symbol: '£', flag: '🇬🇧' },
	[CurrencyEnum.Sek]: { code: CurrencyEnum.Sek, name: 'Swedish Krona', symbol: 'kr', flag: '🇸🇪' },
	[CurrencyEnum.Nok]: {
		code: CurrencyEnum.Nok,
		name: 'Norwegian Krone',
		symbol: 'kr',
		flag: '🇳🇴',
	},
};

interface CurrencyState {
	selectedCurrency: CurrencyEnum;
	setCurrency: (currency: CurrencyEnum) => void;
}

export const useCurrencyStore = create<CurrencyState>()(
	persist(
		(set) => ({
			selectedCurrency: CurrencyEnum.Dkk,
			setCurrency: (currency: CurrencyEnum) => set({ selectedCurrency: currency }),
		}),
		{ name: 'admin-currency-storage' }
	)
);
